import Modal from 'react-bootstrap/Modal';
import { HotTable } from '@handsontable/react';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useAuth } from 'react-oidc-context';

import { Box, Button, CircularProgress, ListItem, ListItemButton, ListItemText, styled } from '@mui/material';
import { Form } from 'react-bootstrap';
import { SnackbarContext } from '../../../App';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default ({ show, onHide, documentId }) => {
  const auth = useAuth();

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

  const [
    emailAddress,
    setEmailAddress,
  ] = useState('');

  const [
    emailSubject,
    setEmailSubject,
  ] = useState('');

  const [
    emailBody,
    setEmailBody,
  ] = useState('');

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const [
    buttonDisable,
    setButtonDisable,
  ] = useState(true);

  function sendEmailHandler() {
    fetch(`${window.origin}/api/client-communication/${documentId}/forward`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${auth.user?.access_token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        destinationEmail: emailAddress,
        contactName: '',
        emailSubject: emailSubject,
        emailBody: emailBody,
      }),
    }) // Replace with your actual API endpoint
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch the PDF');
        }
        return response.json();
      })
      .then((data) => {

      })
      .catch((err) => {

      });

    setSnackBarMessage('Document Forwarded');
    setSnackBarShow(true);
    onHide();
  }

  return (
    <div style={{ padding: '2vw 3vw', textAlign: 'center', color: 'rgb(0, 15, 30, 0.7)' }}>
      <h4 style={{ textAlign: 'center', fontSize: '1.3vw', marginBottom: '2vw', fontWeight: '600' }}>Forward to Client</h4>
      <p style={{ margin: 0, marginBottom: '0vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.7)' }}>Send an email with document attached to a client email</p>
      {isLoading && <CircularProgress style={{ marginBottom: '1vw', color: 'white' }} />}
      {!isLoading && <br />}
      <div>
        <Form.Group style={{ marginBottom: '2vw', flex: 1, textAlign: 'left' }}>
          <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw' }}>Email Address</p>
          <Form.Control style={{ height: '3vw', backgroundColor: 'rgba(0, 0, 0,.03)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="email" placeholder="client@example.com" value={emailAddress} onChange={e => setEmailAddress(e.target.value)} />
        </Form.Group>
        <Form.Group style={{ marginBottom: '2vw', flex: 1, textAlign: 'left' }}>
          <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw' }}>Email Subject</p>
          <Form.Control autocomplete="new-emailSubject" style={{ height: '3vw', backgroundColor: 'rgba(0, 0, 0,.03)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="text" placeholder="Email Subject" value={emailSubject} onChange={e => setEmailSubject(e.target.value)} />
        </Form.Group>
        <Form.Group style={{ marginBottom: '2vw', flex: 1, textAlign: 'left' }}>
          <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw' }}>Email Body</p>
          <Form.Control as="textarea" style={{ height: '10vw', maxHeight: '10vw', backgroundColor: 'rgba(0, 0, 0,.03)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', padding: '1vw 0.8vw' }} placeholder="Body" value={emailBody} onChange={e => setEmailBody(e.target.value)} />
        </Form.Group>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Button
            onClick={onHide}
            variant="outlined"
            style={{
              borderColor: 'rgb(255, 255, 255, 1)',
              color: '#1c6c6c',
              padding: '0.3vw 0.5vw',
              border: 'none',
              backgroundColor: 'rgb(255, 255, 255, 0)',
              borderRadius: '0.5vw',
              textTransform: 'none',
              fontSize: '0.75vw',
              fontWeight: 500,
              letterSpacing: '0.08vw',
              marginRight: '1.5vw',
            }}
          >
            Discard
          </Button>

          <Button
            variant="outlined"
            onClick={sendEmailHandler}
            style={{
              borderColor: 'rgb(255, 255, 255, 1)',
              color: 'rgb(255, 255, 255, 0.9)',
              padding: '0.5vw 0.8vw',
              border: 'none',
              backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)',
              borderRadius: '0.5vw',
              textTransform: 'none',
              fontSize: '0.8vw',
              fontWeight: 500,
              letterSpacing: '0.08vw',
            }}
          >
            Send Email
          </Button>
        </div>
      </div>
    </div>
  );
};


